import React, { FunctionComponent } from 'react';
import { BlogPostData } from 'utils';

import { Avatar, Button, Col, Divider, Heading, P } from '@savebetter/components';

import { BlogPostCustomData } from './FilteredBlogPosts';
import { MediaProps } from './Media';

interface BlogPostProps {
  blogPostData: BlogPostData;
  index: number;
  title: string;
  image: MediaProps[];
  intro?: string;
  blogPostCustomData?: BlogPostCustomData;
}
const BlogPost: FunctionComponent<React.PropsWithChildren<BlogPostProps>> = ({
  index,
  title,
  image,
  intro,
  blogPostData,
  blogPostCustomData
}) => (
  <div key={`blog-post-${index}`} className="m-2 md:mb-12">
    <Col key={index}>
      {image.length > 0 && (
        <a href={blogPostData.node.full_slug} target="_self">
          <Avatar
            src={
              blogPostCustomData && blogPostCustomData?.media.length > 0
                ? blogPostCustomData?.media[0].img
                : image[0].img
            }
            size="xl"
            alt={
              blogPostCustomData && blogPostCustomData?.media.length > 0
                ? blogPostCustomData?.media[0].alt
                : image[0].alt
            }
            loading="lazy"
            circle={false}
            wrapperClassName="w-full"
          />
        </a>
      )}
      <a href={blogPostData.node.full_slug} target="_self">
        <Heading kind="3" color="text-primary" className="my-7">
          {blogPostCustomData?.title ? blogPostCustomData?.title : title}
        </Heading>
      </a>

      {intro && <P>{blogPostCustomData?.description ? blogPostCustomData?.description : intro}</P>}
      <div className="flex mt-7">
        <Button kind="primary" href={blogPostData.node.full_slug} target="_self">
          Read full article
        </Button>
      </div>
      <Divider
        className={'md:hidden mt-9 mb-3'}
        direction="horizontal"
        thickness="thin"
        size="full"
        color="border-black-60"
      />
    </Col>
  </div>
);

export default BlogPost;
